module.exports = __webpack_public_path__ + "img/icon-QR.cad7210e.svg";